import { Injectable } from "@angular/core";
import {
    ActivatedRouteSnapshot,
    CanActivate,
    CanActivateChild,
    CanMatch,
    Route,
    Router,
    RouterStateSnapshot,
    UrlSegment,
    UrlTree
} from "@angular/router";
import { NzNotificationService } from "ng-zorro-antd/notification";

import { LoginService } from "../services/login.service";

@Injectable({ providedIn: "root" })
export class SwitchAccountAccessGuard implements CanActivate, CanActivateChild, CanMatch {
    constructor(
        private readonly loginService: LoginService,
        private readonly router: Router,
        private readonly notification: NzNotificationService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
        return this.evaluate();
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
        return this.evaluate();
    }

    canMatch(route: Route, segments: UrlSegment[]): boolean | UrlTree {
        return this.evaluate();
    }

    private evaluate(): boolean | UrlTree {
        if (this.loginService.canSwitchAccounts()) {
            return true;
        }

        this.notification.warning("Access denied", "You don't have access to the requested page.");
        return this.router.parseUrl("/dashboard/home");
    }
}
